export default "__VITE_ASSET__80178934__"